import React, { useId, useState } from 'react';
import { FiChevronDown, FiSliders } from 'react-icons/fi';
import './css/ResponsiveDashboard.css';

/**
 * Wraps toolbar filter controls. On desktop the wrapper is layout-transparent
 * (`display: contents`), so existing toolbar styling is unchanged; on tablet and
 * phone the controls fold behind a "Filters" toggle.
 */
export default function CollapsibleFilters({ children, label = 'Filters', activeCount = 0, className = '' }) {
  const [open, setOpen] = useState(false);
  const bodyId = useId();

  return (
    <div className={`rt-filters${open ? ' rt-filters--open' : ''}${className ? ` ${className}` : ''}`}>
      <button
        type="button"
        className="rt-filters__toggle"
        aria-expanded={open}
        aria-controls={bodyId}
        onClick={() => setOpen((v) => !v)}
      >
        <FiSliders aria-hidden="true" />
        <span>{label}</span>
        {activeCount > 0 ? <span className="rt-filters__badge">{activeCount}</span> : null}
        <FiChevronDown className="rt-filters__caret" aria-hidden="true" />
      </button>
      <div id={bodyId} className="rt-filters__body">
        {children}
      </div>
    </div>
  );
}
